// Standalone so `routeURLs` and the router can use these tabs without importing the page itself,
// which would pull the page and its dependencies into the initial bundle.
export enum DASHBOARD_TABS {
  SALE = 'sales',
  LEADERSHIP = 'leadership',
  LEADERBOARD = 'leaderboard',
  CLIENT_ANALYTICS = 'client-analytics'
}
